module.exports = __webpack_public_path__ + "bbae7d7e774e036d51128eb0baf559d8.png";